import { makeStyles } from '@mui/styles'
import { Theme } from '../../../../../UI'

export default makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column',
    gap: '16px',
    padding: '16px',
    borderRadius: '16px',
    width: 'fit-content'
  },
  column: {
    display: 'flex',
    flexFlow: 'column',
    gap: '16px',
    overflow: 'overlay',
    height: '600px'
  }
}))
